import { useAuthModal } from "../../../providers/AuthModalProvid";
import { colors, typography } from "../../../design/tokens";

export function AppStoreRankingsSignInPrompt() {
  const { show: showAuthModal } = useAuthModal();

  return (
    <div className="flex flex-col items-center justify-center py-12 mt-8">
      <h3
        className={`${typography.size.lg} ${typography.weight.semibold} text-primary-blue mb-2 text-center`}
      >
        See More App Store Rankings with a Free Account
      </h3>
      <p className={`${typography.size.sm} ${colors.text.secondary} mb-6 text-center`}>
        Sign up to see all the apps ranked in this list
      </p>
      <div className="flex items-center gap-4">
        <button
          onClick={showAuthModal}
          className={`px-4 py-2 border border-dark-border rounded-full ${colors.text.primary} ${typography.size.sm} ${typography.weight.semibold} tracking-wide hover:bg-white/5 transition-colors`}
        >
          Sign in
        </button>
        <button
          onClick={showAuthModal}
          className={`px-4 py-2 bg-primary-blue rounded-full ${colors.text.primary} ${typography.size.sm} ${typography.weight.semibold} tracking-wide hover:opacity-90 transition-opacity`}
        >
          Sign up
        </button>
      </div>
    </div>
  );
}
